import { render, staticRenderFns } from "./broadcastReplyDetail.vue?vue&type=template&id=2e0e0122&scoped=true&"
import script from "./broadcastReplyDetail.vue?vue&type=script&lang=js&"
export * from "./broadcastReplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./broadcastReplyDetail.vue?vue&type=style&index=0&id=2e0e0122&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e0122",
  null
  
)

export default component.exports